import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import Icon1 from './Icon1';
import Icon2 from './Icon2';
import styles from './index.module.scss';

export default function SectionA3() {
    const { t } = useLang('theProduct.SectionCold');

    return (
        <div className={`page-sectionA3 ${styles.SectionA3}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.SectionA3}`}>
                <div className="content">
                    <EfImg
                        className="img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1748341034666/%E9%98%B2%E6%B0%B4.png"
                        pad="https://websiteoss.ecoflow.com/upload/image/1748341034666/%E9%98%B2%E6%B0%B4.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1748424244635/%E9%98%B2%E6%B0%B4_M.png"
                    />
                    <div className="tempContainer">
                        <div className="tempItem">
                            <Icon1 />
                            <span>65°C</span>
                        </div>
                        <div className="tempItem">
                            <Icon2 />
                            <span>-40°C</span>
                        </div>
                    </div>
                </div>
            </div>

            <EcoSpace />
        </div>
    );
}
